import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function Pagination({ page, totalPages, onPageChange }) {
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => onPageChange(Math.max(page - 1, 1))}
        disabled={page === 1}
        className="p-2 border rounded-lg hover:bg-gray-100 disabled:opacity-40"
      >
        <FiChevronLeft size={14} />
      </button>
      <span className="text-sm text-gray-600">{page} / {totalPages}</span>
      <button
        onClick={() => onPageChange(Math.min(page + 1, totalPages))}
        disabled={page === totalPages}
        className="p-2 border rounded-lg hover:bg-gray-100 disabled:opacity-40"
      >
        <FiChevronRight size={14} />
      </button>
    </div>
  );
}
